import { render } from "./electronicScaleSetup.vue?vue&type=template&id=00b559d6"
import script from "./electronicScaleSetup.vue?vue&type=script&lang=js"
export * from "./electronicScaleSetup.vue?vue&type=script&lang=js"

import "./electronicScaleSetup.vue?vue&type=style&index=0&id=00b559d6&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__